"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileConnect = exports.useUserIdentityContext = exports.UserIdentityContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_use_1 = require("react-use");
var ProfileConnectService_1 = require("./ProfileConnectService");
var Context = (0, react_1.createContext)(null);
var DEFAULT_URLS = {
    getProfileConnectUrl: 'api/V1/profileConnect/getRedirectDetails',
    getProfileConnectUserDetails: 'api/V1/profileConnect/getUserDetails',
};
var useCachedResultCallback = function (disabled, executeCallback) {
    var resultRef = (0, react_1.useRef)();
    var executeCallbackRef = (0, react_use_1.useLatest)(executeCallback);
    return (0, react_1.useCallback)(function (force) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (disabled)
                return [2 /*return*/, null];
            if (resultRef.current && !force)
                return [2 /*return*/, resultRef.current];
            resultRef.current = executeCallbackRef.current();
            return [2 /*return*/, resultRef.current];
        });
    }); }, [disabled]);
};
var UserIdentityContextProvider = function (_a) {
    var appId = _a.appId, disableProfileConnect = _a.disableProfileConnect, axiosInstance = _a.axiosInstance, urls = _a.urls, children = _a.children;
    var api = axiosInstance !== null && axiosInstance !== void 0 ? axiosInstance : axios_1.default;
    var fetchProfileConnectUrl = useCachedResultCallback(disableProfileConnect, function () {
        var _a;
        return ProfileConnectService_1.ProfileConnectService.getProfileConnectUrl(api, (_a = urls === null || urls === void 0 ? void 0 : urls.getProfileConnectUrl) !== null && _a !== void 0 ? _a : DEFAULT_URLS.getProfileConnectUrl);
    });
    var fetchProfileConnectUserDetails = useCachedResultCallback(disableProfileConnect, function () {
        var _a;
        return ProfileConnectService_1.ProfileConnectService.getProfileConnectUserDetails(api, (_a = urls === null || urls === void 0 ? void 0 : urls.getProfileConnectUserDetails) !== null && _a !== void 0 ? _a : DEFAULT_URLS.getProfileConnectUserDetails);
    });
    var context = {
        appId: appId,
        profileConnect: {
            disabled: !!disableProfileConnect,
            fetchUrl: fetchProfileConnectUrl,
            fetchUserDetails: fetchProfileConnectUserDetails,
        },
    };
    return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) })));
};
exports.UserIdentityContextProvider = UserIdentityContextProvider;
var useUserIdentityContext = function () {
    var context = (0, react_1.useContext)(Context);
    if (context)
        return context;
    throw new Error('No context found, please ensure you are using this hook from inside a UserIdentityContextProvider');
};
exports.useUserIdentityContext = useUserIdentityContext;
var useProfileConnect = function () {
    var profileConnect = (0, exports.useUserIdentityContext)().profileConnect;
    return profileConnect;
};
exports.useProfileConnect = useProfileConnect;
//# sourceMappingURL=UserIdentityContextProvider.js.map